import { IconProps } from './IconProps';

export const RightArrow = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="11px"
      height="11px"
      viewBox="0 0 11 11"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>carousel arrow</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="carousel-arrow"
          transform="translate(0.500000, 0.092893)"
          fill={props.fill ?? '#FFFFFF'}
        >
          <g
            id="icon-/-16-/-System-/---&gt;"
            transform="translate(0.000000, 0.000000)"
          >
            <polygon
              id="Path"
              points="8.66666667 4.40710678 8.66666667 6.40710678 0 6.40710678 0 4.40710678"
            ></polygon>
            <polygon
              id="Path"
              points="4.37377345 0 9.7475469 5.37377345 4.37377345 10.7475469 2.95955989 9.33333333 6.919 5.37310678 2.95955989 1.41421356"
            ></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
};

